import * as Yup from "yup";

export const ChequeAddFormValidation = Yup.object({
  cheque_id: Yup.string("شماره چک را وارد کنید").required(
    "شماره چک  را وارد کنید",
  ),
  recieverable_type: Yup.string("نوع گیرنده را مشخص کنید")
    .required("نوع گیرنده را مشخص کنید"),
  recieverable_id: Yup.string("گیرنده را مشخص کنید")
    .typeError("گیرنده را بنویسید")
    .required("گیرنده را مشخص کنید")
    .nullable(true),
  due_date: Yup.string().nullable().required("تاریخ وارد نمایید"),
  amount: Yup.string()
    .typeError("عدد وارد نمایید")
    .required("مبلغ وارد نمایید"),
  status: Yup.string("وضعیت را مشخص نمایید").required("وضعیت را مشخص نمایید"),
  // returned_date : Yup.string().nullable().test('test-name','تاریخ برگشت و پاس شده را پاک کنید',function(value,data){
  //     const{parent} = data;
  //
  //     if(value != null && (parent.bounced_date!= null || parent.cashed_date!= null))
  //     {
  //         return false
  //     }
  //
  //     return true
  // }),
  // cashed_date : Yup.string().nullable().test('test-name','تاریخ برگشت و عودت شده را پاک کنید',function(value,data){
  //     const{parent} = data;
  //
  //
  //     if(value != null && (parent.bounced_date!= null || parent.returned_date!= null))
  //     {
  //         return false
  //     }
  //
  //     return true
  // }),
  // bounced_date : Yup.string().nullable().test('test-name','تاریخ عودت و پاس شده را پاک کنید',function(value,data){
  //     const{parent} = data;
  //
  //     if(value != null &&  (parent.returned_date!= null || parent.cashed_date!= null))
  //     {
  //         return false
  //     }
  //
  //     return true
  // }),
  // buyer_usage_kilometer : Yup.number().typeError("عدد وارد نمایید").positive().integer(),
  // seller_usage_kilometer : Yup.number().typeError("عدد وارد نمایید").positive().integer()
  // lastname :Yup.string("نام خانوادگی را وارد کنید")
  //     .required("نام خانوادگی  را وارد کنید"),
  // id_card_number : Yup.number('کد ملی بدون خط تیره وارد کنید')
  //     .required("کد ملی را وارد نمایید"),
  // email : Yup.string().email("ایمل وارد نمایید"),
  // credit : Yup.number('عدد وارد نمایید')
});
